import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { StockServices } from '../../../stock/services';

/**
 * Generated class for the DishTutorialSlidePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-stock-tutorial-slide',
  templateUrl: 'stock-tutorial-slide.html',
})
export class StockTutorialSlidePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public stockServices: StockServices) {
  }

  ionViewDidLoad() {
  }

  ionViewDidLeave() {
    this.closeLeave();
  }

  close() {
    this.globals.restaurant.tutorial_stock = true;
    this.stockServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_stock': this.globals.restaurant.tutorial_stock,
    }).then(() => {
      this.navCtrl.pop();
    });

  }

  closeLeave(){
    this.globals.restaurant.tutorial_stock = true;
    this.stockServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_stock': this.globals.restaurant.tutorial_stock,
    }).then(() => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/help/tutorial-slider/stock-tutorial-slide/stock-tutorial-slide.ts